import appRequest from './request'

// 获取图形验证码
export const verifyCode = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/getVerifyCode',
        data,
        method: 'POST'
    })
};

// 校验登录手机验证码
export const verifyPhoneCode = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/verifyPhoneCode',
        data,
        method: 'POST'
    })
};

// 登录接口
export const login = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/login',
        data,
        method: 'POST',
        headers: {
            traceId: sessionStorage.getItem('Traceid')
        }
    })
};

// 获取登录短信验证码
export const sendMessage = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/getPhoneCode',
        data,
        method: 'POST'
    })
};

// 验证登录图形验证码
export const verifyImgCode = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/verifyCode',
        data,
        method: 'POST'
    })
};


// 基础资料查询接口
export const bdquery = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmbs/bd/query',
        data,
        method: 'POST'
    })
};

// 企业代码校验接口
export const checkTenant = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/checkTenant',
        // data,
        method: 'POST',
        headers: {
            tenantAlias: data
        }
    })
};

// 获取getAccessToken
export const getAccessToken = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/getAccessToken',
        data,
        method: 'POST'
    })
};

// 上传图片接口
export const uploadImage = (data) => {
    return appRequest({
        url: 'ierp/image/uploadImage.do',
        data,
        method: 'POST'
    })
};

// 注册接口
export const regist = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/regist',
        data,
        method: 'POST'
    })
};


// 获取不同环境的数据中心不一样的Accountid 
export const getAllDatacenters = (data) => {
    return appRequest({
        url: '/auth/getAllDatacenters.do',
        data,
        method: 'POST'
    })
};

// 获取银行列表
export const getBankList = (data) => {
    return appRequest({
        url: 'kapi/v2/xn/xn_lssmcm/account/getBankList',
        data,
        method: 'POST'
    })
};